import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GasMenu } from '../gas-menu/gas-menu.namespace';

import { GasMenuService } from '../gas-menu/gas-menu.service';
import { GasLayoutService } from './gas-layout.service';

@Component({
  selector: 'gas-layout',
  templateUrl: './gas-layout.component.html',
  styleUrls: ['./gas-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasLayoutComponent {
  public isMenu$: Observable<boolean> = this.gasMenuService.meta$
    .pipe(
      map((meta: GasMenu.Meta) => Boolean(meta) && meta?.routes?.length > 0),
    );
  public topComponent$ = this.gasLayoutService.topComponent$;
  public headerBottomComponent$ = this.gasLayoutService.headerBottomComponent$;
  public botComponent$ = this.gasLayoutService.botComponent$;

  constructor(
    private gasMenuService: GasMenuService,
    private gasLayoutService: GasLayoutService,
  ) {}
}
